module.exports = "<div class=\"form-area-stage {{theme | themeClass}}\"> <slot></slot> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/common/components/base/form-area/form-area.tpl
// module id = 939
// module chunks = 2